export default __webpack_public_path__ + "static/media/product-07 (1).9402d058.jpg";